import Lottie from 'lottie-react';
import * as React from 'react';

import buddyHoverAnimation from '@/assets/animations/buddyHover.json';
import { cn } from '@/utils';

interface ClosedViewMobileProps {
  isDragging: boolean;
  wasDragged: boolean;
  handleToggleOpen: () => void;
}

export const ClosedViewMobile = ({
  isDragging,
  wasDragged,
  handleToggleOpen,
}: ClosedViewMobileProps) => (
  <div className="sm:hidden flex items-center gap-2 bg-magical-moonlight-d3 border border-magical-moonlight-d1 rounded-2xl px-3 py-2 shadow-lg">
    <button
      type="button"
      className={cn(
        'relative w-12 h-12 rounded-xl overflow-hidden',
        'bg-magical-moonlight-d3',
        'flex items-center justify-center',
        'cursor-pointer transition-all duration-200',
        isDragging && 'scale-95'
      )}
      onClick={e => {
        e.stopPropagation();
        if (!isDragging && !wasDragged) {
          handleToggleOpen();
        }
      }}
      aria-label="Open BhanzuBuddy chat"
    >
      <div className="w-full h-full">
        <Lottie
          animationData={buddyHoverAnimation}
          loop={true}
          autoplay={true}
          className="w-full h-full"
        />
      </div>
    </button>
  </div>
);
